/** Matches the legacy screen's `Pagination.first()` default. */
export const USERS_PAGE_SIZE = 10;

export const FIRST_PAGE = 1;
